import type { DialogTree } from '@/types';

const roomDialog = {
  room_1: { 
    id: 'part2_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    sfx : "openDoor",
    nextDialogId: 'room_2',
    autoplay : 1.5,
    fade : true,
  },
  room_2: {
    id: 'part2_1',
    speaker: 'Yan',
    text: `Ruang tamu ini, membawa banyak kenangan`,
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId: 'room_3',
    fade : true,
  },
  room_3: {
    id: 'part2_1',
    speaker: 'Yan',
    text: `Coba kita lihat apakah ada yang berubah`,
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    characterImage: '/assets/character/v2/yanf.png',
    nextDialogId: 'room_hub',
  },

  room_hub: {
    id: 'part2_1',
    speaker: '',
    text: `Inspeksi ruang tamu`,
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    nextDialogId: 'room_g1',
    clickables: [
      {
        text: 'Foto',
        nextDialogId: 'room_a1',
        locationX : 12,
        locationY : 74,
      },
      {
        text: 'Meja Makan',
        nextDialogId: 'room_d0',
        locationX : 38,
        locationY : 63,
      },

      {
        text: 'Kalender',
        nextDialogId: 'room_b1',
        locationX : 91.5,
        locationY : 30,
      },

      {
        text: 'Tas',
        nextDialogId: 'room_h1',
        locationX : 76,
        locationY : 70,
      },
      // {
      //   text: 'Kamar Nenek',
      //   nextDialogId: 'room_e1',
      // },
      // {
      //   text: 'Kamar Diana',
      //   nextDialogId: 'room_f1',
      // },
    ],
  },
  room_h1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Ini adalah tas milik elsa`,
    backgroundImage: '/assets/backdrop/ruang_tamu_sofa.ktx2',
    nextDialogId : "room_h2"
  },
  room_h2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Dia tidak membawa banyak barang. Hanya beberapa baju dan sebuah buku.`,
    backgroundImage: '/assets/backdrop/ruang_tamu_sofa.ktx2',
    nextDialogId : "room_hub"
  },

  room_a1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Ini adalah kumpulan foto-foto`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_foto.ktx2',
    nextDialogId : "room_a2"
  },
  room_a2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Foto ini sepertinya foto nenek ku, dan orang yang disebelahnya...`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_foto.ktx2',
    nextDialogId : "room_a3"
  },
  room_a3: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Yang menggunakan kalung emas, adalah ibu ku.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_foto.ktx2',
    nextDialogId : "room_hub"
  },

  room_b1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Menarik, ada tanggal yang dilingkari`,
    backgroundImage: '/assets/backdrop/ruang_tamu_kalender.ktx2',
    nextDialogId : "room_b2"
  },
  room_b2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Sepertinya itu hari ini...`,
    backgroundImage: '/assets/backdrop/ruang_tamu_kalender.ktx2',
    nextDialogId : "room_b3"
  },
  room_b3: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Tulisannya.. Ulang Tahun ke 17 Diana...`,
    backgroundImage: '/assets/backdrop/ruang_tamu_kalender.ktx2',
    nextDialogId : "room_b4"
  },
  room_b4: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Wah aku sama sekali lupa, aku tidak menyiapkan apa-apa`,
    backgroundImage: '/assets/backdrop/ruang_tamu_kalender.ktx2',
    nextDialogId : "room_hub"
  },

  room_c1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Kebanyakan alat disini adalah alat-alat yang tua`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_zoomed.ktx2',
    nextDialogId : "room_c2"
  },
  room_c2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Mungkin alat-alat dapur ini lebih tua dariku.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_zoomed.ktx2',
    nextDialogId : "room_hub"
  },

  room_d0: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Di meja ada rosario milik nenek`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_meja_makan_zoomed.ktx2',
    nextDialogId : "room_d1"
  },
  room_d1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Dan juga ada pisang goreng dan sambal`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_meja_makan_zoomed.ktx2',
    nextDialogId : "room_d2"
  },
  room_d2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Kombinasi makanan ini tidak ditemukan di kota`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_meja_makan_zoomed.ktx2',
    nextDialogId : "room_d3"
  },
  room_d3: {
    id: 'room_g1',
    speaker: 'Yan',
    text: 'Perutku lapar, tidak ada salahnya jika aku makan ini.',
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_meja_makan_zoomed.ktx2',
    nextDialogId : "room_hub"
  },

  room_e1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Pintu nenek tertutup`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_meja_makan_zoomed.ktx2',
    nextDialogId : "room_e2"
  },
  room_e2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Sebaiknya tidak menggangu istirahat nenek`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    nextDialogId : "room_hub"
  },

  room_f1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Pintu Diana sedikit terbuka.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    nextDialogId : "room_f2"
  },
  room_f2: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Coba aku mengintip`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    nextDialogId : "room_f3"
  },
  room_f3: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Tidak ada siapa-siapa. Sepertinya Diana dan Elsa sudah keluar.`,
    backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
    nextDialogId : "room_hub"
  },

  room_g1: {
    id: 'room_g1',
    speaker: 'Yan',
    text: `Baiklah, saatnya keluar dan eksplorasi desa.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/ruang_tamu_with_rosario.ktx2',
    isEnd : true
  },
}

const part2Dialog = {
  ...roomDialog,
  part2_1: {
    id: 'part2_1',
    speaker: '',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    autoplay : 1.5,
    sfx : "chicken",
    nextDialogId: 'part2_2',
    fade : true,
  },
  part2_2: {
    id: 'part2_2',
    speaker: 'Yan',
    text: `Sudah pagi, sebaiknya aku beranjak keluar`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/kamar_yan.ktx2',
    nextDialogId: 'room_1',
    fade : true,
  },
  part2_3: {
    id: 'part2_1',
    speaker: 'Yan',
    text: ``,
    backgroundImage: '/assets/cutscene/black.ktx2',
    sfx : "openDoor",
    autoplay : 1.5,
    nextDialogId: 'part2_4',
    fade : true,
  },
  part2_4: {
    id: 'part2_4',
    speaker: 'Yan',
    text: `Sepertinya mereka tidak di kamar.`,
    backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
    nextDialogId: 'part2_5',
    fade : true,
  },
  part2_5: {
    id: 'part2_5',
    speaker: 'Yan',
    text: `Apakah nenek sudah bangun?`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/interior_rumah.ktx2',
    nextDialogId: 'part2_5a',
  },
  part2_5a : {
    id: 'part2_5a',
    speaker: 'Yan',
    text: `Apakah nenek sudah bangun?`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/interior_rumah.ktx2',
    choices: [
      {
        text: '[Ketuk Pintu]',
        nextDialogId: 'part2_6',
      },
      {
        text: '[Jangan Menggangu]',
        nextDialogId: 'part2_7',
      },
    ],
  },
  part2_6: {
    id: 'part2_7',
    speaker: '',
    text: ``,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/interior_rumah.ktx2',
    sfx : 'doorKnock',
    nextDialogId: 'part2_6a',
    autoPlay: 2
  },
  part2_6a: {
    id: 'part2_7', 
    speaker: 'Yan',
    text: `Sepertinya tidak ada respons.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/interior_rumah.ktx2',
    sfx : 'doorKnock',
    nextDialogId: 'part2_7',
  },
  part2_7: {
    id: 'part2_7',
    speaker: 'Yan',
    text: `Baiklah, saatnya keluar dan eksplorasi desa.`,
    characterImage: '/assets/character/v2/yanf.png',
    backgroundImage: '/assets/backdrop/interior_rumah.ktx2',
    isEnd : true
  },
}

const config: DialogTree = {
  // startDialogId: 'room_3',
  startDialogId: 'day1_opening1',
  nodes: {
    day1_opening1: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Selamat datang Kak!`,
      characterImage: '/assets/character/v2/diana_h.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening2',
    },
    day1_opening2: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Akhirnya kamu sampai juga. Sudah lama sekali kita tidak bertemu.`,
      characterImage: '/assets/character/v2/bunga_h.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening3',
    },
    day1_opening3: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Siapa itu bersama kamu?`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening4',
    },
    day1_opening4: {
      id: 'day1_opening4',
      speaker: '',
      text: `Siapa itu bersama kamu?`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/portal.png',
      choices: [
        {
          text: 'Elsa adalah temanku',
          nextDialogId: 'day1_opening4a',
          storyActions : [
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : -1} },
          ]
        },
        {
          text: 'Elsa adalah temanku yang istimewa',
          nextDialogId: 'day1_opening4b',
          storyActions : [
            { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
          ]
        },
      ],
    },
    day1_opening4a: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Ini adalah Elsa, temanku`,
      characterImage: '/assets/character/v2/yanf.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening5',
    },
    day1_opening4b: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Ini adalah Elsa, pacarku.`,
      characterImage: '/assets/character/v2/yanf.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening5',
    },
    day1_opening5: {
      id: 'day1_opening',
      speaker: 'Elsa',
      text: `Haloo, aku Elsa, salam kenal semua`,
      characterImage: '/assets/character/v2/elsa_h.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening6',
    },
    day1_opening6: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Selamat datang kak Elsa! Semoga betah di desa ini!`,
      characterImage: '/assets/character/v2/diana_h.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening7',
    },
    day1_opening7: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Elsa, Aku teman terbaik Yan dari kecil.`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening8',
    },
    day1_opening8: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ayo, kita kembali ke rumah dulu, sudah cukup gelap diluar. Nenek sudah menunggu didalam`,
      characterImage: '/assets/character/v2/diana_h.png',
      backgroundImage: '/assets/backdrop/portal.png',
      nextDialogId: 'day1_opening9',
    },
    day1_opening9: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: 'day1_opening10',
      sfx : "openDoor",
      fade : true,
      autoplay : 1.5
    },
    day1_opening10: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Halo nek, apakah nenek sudah istirahat? Yan sudah pulang`,
      characterImage: '/assets/character/v2/diana_h.png',
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.ktx2',
      nextDialogId: 'day1_opening11',
      fade : true,
    },
    day1_opening11: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Silahkan masuk`,
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.ktx2',
      nextDialogId: 'day1_opening12',
    },
    day1_opening12: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Senang sekali masih bisa melihat kamu. `,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening12b',
      fade : true
    },
    day1_opening12b: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Sepertinya waktu nenek sudah tidak lama, nenek sekarang sudah sulit sekali bergerak.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening13',
    },

    day1_opening12c: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Bagaimana sekolah? Apakah sulit menjadi dokter?`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening13',
    },
    day1_opening12d: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Bagaimana sekolah? Apakah sulit menjadi dokter?`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      choices: [
        {
          text: '[Bohong] Tidak sama sekali, aku murid nomor 1 dikelas!',
          nextDialogId: 'day1_opening12e',
        },
        {
          text: '[Jujur] Cukup menantang nek, tetapi aku masih bertahan.',
          nextDialogId: 'day1_opening12e',
        },
      ],
    },
    day1_opening12e: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Nenek sangat bangga kepada mu Yan.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening12f',
    },
    day1_opening12f: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Nenek berdoa, suatu hari kamu bisa berguna untuk semua orang.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening13',
    },

    day1_opening13: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Siapa ini bersama kamu? Pacar kamu?`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening14',
    },
    day1_opening14: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      choices: [
        {
          text: '[Goda] Betul nek, Elsa pacar ku',
          nextDialogId: 'day1_opening15',
          storyActions : [
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : 1} },
            { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
          ]
        },
        {
          text: '[Sangkal] Bukan nek! Aku dan Elsa sekedar teman biasa.',
          nextDialogId: 'day1_opening15',
          storyActions : [
            { type: 'addCustomValue', value: {key : "elsa_affinity", value : -1} },
            { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : 1} },
          ]
        },
        {
          text: '[Kenalkan Elsa sebagai teman]',
          nextDialogId: 'day1_opening14c',
        },
      ],
    },
    day1_opening14a: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Betul nek, Elsa pacar ku`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      characterImage: '/assets/character/v2/yanf.png',
      nextDialogId: 'day1_opening15',
    },
    day1_opening14b: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Bukan nek! Aku dan Elsa sekedar teman biasa.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      characterImage: '/assets/character/v2/yanf.png',
      nextDialogId: 'day1_opening15',
    },
    day1_opening14c: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Elsa adalah temanku nek.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      characterImage: '/assets/character/v2/yanf.png',
      nextDialogId: 'day1_opening15',
    },
    day1_opening15: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Halo Elsa, selamat datang dan selamat beristirahat.`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening16',
    },
    day1_opening16: {
      id: 'day1_opening',
      speaker: 'Nenek',
      text: `Selamat malam ya`,
      backgroundImage: '/assets/backdrop/kamar_nenek_zoom.ktx2',
      nextDialogId: 'day1_opening17',
    },
    day1_opening17: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.ktx2',
      nextDialogId: 'day1_opening18',
      fade : true,
      autoplay : 1.5
    },
    day1_opening18: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ayo kita beristirahat`,
      backgroundImage: '/assets/backdrop/kamar_nenek_fill.ktx2',
      characterImage: '/assets/character/v2/diana_h.png',
      nextDialogId: 'day1_opening19',
    },
    day1_opening19: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: 'day1_opening20',
      sfx : "openDoor",
      autoplay : 1.5,
      fade : true,
    },
    day1_opening20: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ini kamarku. Malam ini kak Elsa tidur di kamar ku ya!`,
      characterImage: '/assets/character/v2/diana_h.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20b',
      fade : true,
    },
    day1_opening20b: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Aku juga sebaiknya pulang kerumah. Yan, apakah besok ingin mandi bersama di Danau?`,
      characterImage: '/assets/character/v2/bunga_h.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20c',
    },
    day1_opening20c: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: ``,
      characterImage: '/assets/character/v2/bunga_h.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      choices: [
        {
          text: '[Tolak] Maaf Bunga sepertinya aku lelah',
          nextDialogId: 'day1_opening20ca2',
          storyActions : [
            { type: 'addCustomValue', value: {key : "elsa_bunga_affinity", value : -1} },
            { type: 'addCustomValue', value: {key : "bunga_affinity", value : -1} },
          ]
        },
        {
          text: '[Terima] Ayo, pasti akan sangat menyenangkan',
          nextDialogId: 'day1_opening20d',
          storyActions : [
            { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
          ]
        },
      ],
    },

    day1_opening20cb1: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Ayo, pasti akan sangat menyenangkan`,
      characterImage: '/assets/character/v2/yanf.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20d',
    },

    day1_opening20ca1: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Maaf Bunga sepertinya aku lelah`,
      characterImage: '/assets/character/v2/yanf.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20ca1b',
    },
    day1_opening20ca1b: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Baiklah Yan... aku mengerti`,
      characterImage: '/assets/character/v2/bunga.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20ca2',
    },
    day1_opening20ca2: {
      id: 'day1_opening',
      speaker: 'Elsa',
      text: `Ah padahal sangat menarik, aku juga mau ke danau`,
      characterImage: '/assets/character/v2/elsa_s.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20ca3',
    },
    day1_opening20ca3: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Ayo kak, pasti akan seru sekali di danau.`,
      characterImage: '/assets/character/v2/diana_s.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20ca4',
    },
    day1_opening20ca4: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Jika kalian memang mau, baiklah.`,
      characterImage: '/assets/character/v2/yanf.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening20d',
    },

    day1_opening20d: {
      id: 'day1_opening',
      speaker: 'Bunga',
      text: `Baik kalau begitu, sampai jumpa besok sore ya.`,
      characterImage: '/assets/character/v2/bunga_h.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening22',
    },
    day1_opening21: {
      id: 'day1_opening',
      speaker: 'Diana',
      text: `Sudah malam, sebaiknya kakak juga kembali ke kamar dan beristirahat`,
      characterImage: '/assets/character/v2/diana_h.png',
      backgroundImage: '/assets/backdrop/kamar_diana.ktx2',
      nextDialogId: 'day1_opening22',
    },
    day1_opening22: {
      id: 'day1_opening',
      speaker: '',
      text: ``,
      backgroundImage: '/assets/cutscene/black.ktx2',
      nextDialogId: 'day1_op1',
      sfx : "openDoor",
      autoplay : 1.5,
      fade : true,
    },

    day1_op1: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Ini adalah kamar masa kecil ku`,
      backgroundImage: '/assets/backdrop/kamar_yan.ktx2',
      sfx : "",
      nextDialogId: 'day1_op2',
      fade : true,
    },
    day1_op2: {
      id: 'day1_opening',
      speaker: 'Yan',
      text: `Sayangnya ranjang ku tidak nyaman untuk dua orang`,
      backgroundImage: '/assets/backdrop/kamar_yan.ktx2',
      sfx : "",
      nextDialogId: 'day1_opening23',
    },

    day1_opening23: {
      id: 'day1_opening', 
      speaker: 'Yan',
      text: `Saatnya beristirahat....`,
      backgroundImage: '/assets/cutscene/black.ktx2',
      sfx : "",
      nextDialogId: 'part2_1',
      fade : true,
    },
    ...part2Dialog,
  },
};
export default config;
